import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Utils } from "../../helper/utils.helper";
import { Campaign } from "../../models/campaign.model";
import { PermissionCheck } from "../../shared/permission";

let ConfirmPaymentComponent = {
    selector: "vcConfirmPayment",
    templateUrl:
        "/angular/components/campaign-plan/confirm-payment.component.html",
    bindings: {},
    controller: class ConfirmPaymentController {
        public activeCampaign: Campaign;
        public permissionProvider: PermissionCheck;
        public loading: boolean = true;

        constructor(
            Utils: Utils,
            $window: any,
            CampaignDataProvider: CampaignDataProvider,
            $timeout: any,
            PermissionCheck: PermissionCheck
        ) {
            Utils.accessCheck();
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            this.permissionProvider = PermissionCheck;

            CampaignDataProvider.getOrganisations().then(() => {
                if (!this.activeCampaign.paymentFailed()) {
                    $window.location = "/#/";
                }
            });

            $timeout(() => {
                this.loading = false;
            }, 1500);
        }
    },
};

angular
    .module("campaignplan", [])
    .component(ConfirmPaymentComponent.selector, ConfirmPaymentComponent);
